import * as Yup from 'yup';
import { messages } from 'app/config/constants';
import { PhasedConstructionType } from './phased-construction.model';

export const phasedConstructionValidationSchema = Yup.object({
  phasedConstructionType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  phases: Yup.array()
    .of(
      Yup.object({
        phaseValue: Yup.string().required(messages.MANDATORY_FIELD),
      }),
    )
    .when('phasedConstructionType', {
      is: (value: any[]) => value?.[0]?.id === PhasedConstructionType.PHASED,
      then: schema => schema.min(1, 'Dodaj barem jednu fazu'),
      otherwise: schema => schema.strip(),
    }),
  stages: Yup.array()
    .of(
      Yup.object({
        stageValue: Yup.string().required(messages.MANDATORY_FIELD),
        phases: Yup.array().of(
          Yup.object({
            phaseNumber: Yup.number(),
            phaseValue: Yup.string().required(messages.MANDATORY_FIELD),
          }),
        ),
      }),
    )
    .when('phasedConstructionType', {
      is: (value: any[]) => value?.[0]?.id === PhasedConstructionType.STAGED,
      then: schema =>
        schema.min(1, 'Dodaj barem jednu etapu').test('phases-filled-if-present', 'Faze moraju imati nazive ako su dodane', stages => {
          if (!stages) return true;
          return stages.every(stage => {
            if (!stage.phases?.length) return true;
            return stage.phases.every(phase => !!phase.phaseValue?.trim());
          });
        }),
      otherwise: schema => schema.strip(),
    }),
});
